<template>
  <div class="accordion component --dark">
    <ul
      class="accordion-wrapper container"
      aria-label="Accordion"
    >
      <template v-if="tabs.length > 0">
        <accordion-tab
          v-for="(tab, index) in tabs"
          :key="index"
          @tabToggled="handleTabToggled(index)"
        >
          <li
            :id="`accordion-item-${index + 1}`"
            slot-scope="{ expanded }"
            class="accordion-item"
            :data-component="index === 0 ? 'your-trip' : 'arrival-details'"
          >
            <div class="accordion-item-panel">
              <div class="accordion-item-panel-wrapper">
                <div class="accordion-item-text">
                  <h4 class="accordion-item-title">
                    {{ tab.accordionTitle }}
                  </h4>
                  <span class="accordion-item-description">{{
                    tab.accordionDescription
                  }}</span>
                </div>
                <div class="accordion-item-panel-filler" />
                <button
                  :id="`accordion-control-${index}`"
                  class="button"
                  :class="expanded ? 'expanded' : ''"
                  :aria-controls="`content-${index}`"
                  :aria-expanded="expanded ? 'true' : 'false'"
                  :aria-label="tab.accordionTitle + ' ' + (expanded ? closeLabel : openLabel)"
                  @click.prevent="handleInteraction(index)"
                  @enter="handleInteraction(index)"
                  @keydown.space.prevent="handleInteraction(index)"
                >
                  {{ expanded ? closeLabel : openLabel }}
                </button>
              </div>
            </div>
            <div
              v-if="expanded"
              :id="`content-${index}`"
              class="accordion-item-content"
              :aria-hidden="expanded ? 'false' : 'true'"
            >
              <slot :name="`tab${index + 1}`" />
            </div>
          </li>
        </accordion-tab>
      </template>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'AccordionDark',
    props: {
      tabs: {
        type: Array,
        required: true,
      },
      openLabel: {
        type: String,
        default: 'Edit Preferences',
      },
      closeLabel: {
        type: String,
        default: 'Close',
      },
      useFormHandler: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        expandedTabIndex: null,
      }
    },
    methods: {
      handleTabToggled(toggledIndex) {
        this.$children.forEach((child, index) => {
          if (index !== toggledIndex) {
            child.closeTab()
          }
        })
      },
      handleInteraction(interactedIndex, fromModal, miscData) {
        const preArrivalFormRef = this.useFormHandler ? this.$parent.$refs.preArrivalForm : null
        const hasFormDataChanged = preArrivalFormRef
          ? preArrivalFormRef.formData.preferences.value.length > 0 : false

        if (hasFormDataChanged) {
          if (fromModal) {
            this.expandedTabIndex = this.expandedTabIndex !== miscData.interactedIndex
              ? miscData.interactedIndex : null
            this.scrollToTab(this.expandedTabIndex || 0)
            this.$children[miscData.interactedIndex].toggleTab()
          } else {
            this.$parent.$refs.modalWarning.activate(null, { interactedIndex })
          }
        } else {
          this.expandedTabIndex = this.expandedTabIndex !== interactedIndex ? interactedIndex : null
          this.scrollToTab(this.expandedTabIndex || 0)
          this.$children[interactedIndex].toggleTab()
        }
      },
      async closeTab(closedIndex) {
        if (closedIndex) {
          this.$children[closedIndex].closeTab()
          this.scrollToTab(closedIndex)
        } else {
          this.$children.forEach((child) => {
            child.closeTab()
          })
          this.scrollToTab(0)
        }
      },
      scrollToTab(scrollToIndex) {
        this.$nextTick(() => {
          const element = this.$el.querySelector(`#accordion-item-${scrollToIndex + 1}`)
          if (element) {
            setTimeout(() => {
              element.scrollIntoView({ behavior: 'smooth' })
            }, 100)
          }
        })
      },
    },
  }
</script>
